module.exports = __webpack_public_path__ + "static/media/icon-content-file.d4df3e92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-content-file.svg
// module id = 934
// module chunks = 0